import React from 'react';
import useToggle from '../../hooks/useToggle';
import StyledCertificationDetails, {
  ICertificationDetails,
} from '../../styled/CertificationDetails';

const CertificationDetails = (props: Omit<ICertificationDetails, 'extended' | 'onToggle'>) => {
  const [extended, toggleExtended] = useToggle(false);

  return <StyledCertificationDetails {...props} extended={extended} onToggle={toggleExtended} />;
};

export default CertificationDetails;
